export default __webpack_public_path__ + "static/media/guide_leg.f3f42e98.png";